(function ($, window, undefined) {
    
        var telas = $('#telasAdviseApp');

        telas.owlCarousel({
            stopOnHover: true,
            items: 3,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            margin: 75,
            nav: true,
            loop: true,
            responsive: {
                0: {
                    items: 1
                },
                479: {
                    items: 1
                },
                768: {
                    items: 1
                },
                980: {
                    items: 3
                },
                1024: {
                    items: 3
                }
            }
        });

        telas.on('changed.owl.carousel', function (event) {

            var idItem = $(event.target).find('.owl-item.active:eq(2) div').data('desc');
            console.log(idItem);
            $('.item-carousel').hide();
            $('#' + idItem).fadeIn();

        });
    

}(jQuery, window));
